import React from 'react';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'src/decorator/inject-intl';
import Base from 'src/core/base';

interface Prop {
    content: string;
}
interface State {}

@injectIntl()
export default class Title extends Base<Prop, State> {
    constructor(prop: Prop) {
        super(prop);
    }

    render() {
        const { content } = this.props;
        return (
            <>
                <div className="boxs">
                    <h1 className="toptitle">{content}</h1>
                </div>
            </>
        );
    }
}
